import { ProjectSubfolder } from '@/features/end-of-lease/ProjectSubfolder/ProjectSubfolder';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const subfolderSearchSchema = z.object({
    type: z.string(),
    page: z.number().int().positive().optional().catch(undefined),
    filter: z.string().optional().catch(undefined),
});

export const Route = createFileRoute(
    '/lease/projects/$projectId/folders/$folderLetter/subfolder/',
)({
    component: ProjectSubfolder,
    validateSearch: subfolderSearchSchema,
});
